import { render, staticRenderFns } from "./social-profile-check-dialog.vue?vue&type=template&id=7923f8fb&"
import script from "./social-profile-check-dialog.vue?vue&type=script&lang=js&"
export * from "./social-profile-check-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports